import React, { useState } from 'react';
import { Card, Button, Input, Tag, Popconfirm, message } from 'antd';
import { DeleteOutlined, BookOutlined, EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { addStudentNote } from '../../api/students';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';
import { apiErrorMessage } from '../../utils/apiError';

const roleLabels = {
  developer_admin: 'Geliştirici Admin',
  super_admin: 'Süper Admin',
  branch_manager: 'Şube Müdürü',
  teacher: 'Öğretmen',
  parent: 'Veli',
};

const StudentNotesTab = ({ studentId, notes, onUpdate }) => {
  const [noteText, setNoteText] = useState('');
  const { user: currentUser } = useAuthStore();

  const canDelete = (note) => {
    return note.user_id === currentUser?.id ||
      ['developer_admin', 'super_admin'].includes(currentUser?.role);
  };

  const handleAdd = async () => {
    if (!noteText.trim()) return;
    try {
      await addStudentNote(studentId, { note: noteText });
      setNoteText('');
      message.success('Not eklendi.');
      onUpdate();
    } catch {
      message.error('Not eklenemedi.');
    }
  };

  const handleDelete = async (noteId) => {
    try {
      await api.delete(`/students/${studentId}/notes/${noteId}`);
      message.success('Not silindi.');
      onUpdate();
    } catch (error) {
      message.error(apiErrorMessage(error, 'Not silinemedi.'));
    }
  };

  return (
    <Card>
      <div className="flex gap-2 mb-4">
        <Input.TextArea
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          placeholder="Not ekle..."
          rows={2}
        />
        <Button type="primary" onClick={handleAdd}>Ekle</Button>
      </div>
      {notes.map((note) => (
        <div key={note.id} className="p-3 border rounded mb-2">
          <div className="flex justify-between items-start">
            <div className="flex flex-wrap items-center gap-1">
              {note.lesson_session_id ? (
                <Tag icon={<BookOutlined />} color="geekblue">Ders İçi</Tag>
              ) : (
                <Tag icon={<EditOutlined />} color="default">Manuel</Tag>
              )}
              <strong>{note.user?.name} {note.user?.surname}</strong>
              <Tag color="blue">{roleLabels[note.user?.role] || note.user?.role}</Tag>
              {note.lesson_session && (
                <span className="text-gray-400 text-xs">
                  {note.lesson_session.classroom?.name} · {dayjs(note.lesson_session.date).format('DD.MM.YYYY')} {note.lesson_session.start_time?.slice(0,5)}
                </span>
              )}
              <span className="text-gray-400 text-sm">
                {dayjs(note.created_at).format('DD.MM.YYYY HH:mm')}
              </span>
            </div>
            {canDelete(note) && (
              <Popconfirm
                title="Notu silmek istediğinize emin misiniz?"
                onConfirm={() => handleDelete(note.id)}
                okText="Evet"
                cancelText="Hayır"
              >
                <Button icon={<DeleteOutlined />} danger size="small" />
              </Popconfirm>
            )}
          </div>
          <p className="mt-1">{note.note}</p>
        </div>
      ))}
      {notes.length === 0 && <p className="text-gray-400">Henüz not eklenmemiş.</p>}
    </Card>
  );
};

export default StudentNotesTab;
